// Real club assets pulled from the original Framer source.
// Centralised so we can swap or expand later.

export const HERO_IMAGE =
  "https://framerusercontent.com/images/0VYDiUumQgfDV9wgVAOzQ3D6UfY.webp?width=2000";

// Big gallery used in the original "club" strip
export const CLUB_GALLERY = [
  {
    src: "https://framerusercontent.com/images/CUtRiI0FewNonC33JuNyVtGxZx4.webp?width=2000",
    caption: "Día de partido",
  },
  {
    src: "https://framerusercontent.com/images/EpLweLB56XuZvJdtL8m0nkyB2Yg.webp?width=2000",
    caption: "Vestuario",
  },
  {
    src: "https://framerusercontent.com/images/yC6RrkK8GDYEijjVaX6wb72QOs.webp?width=2000",
    caption: "El equipo",
  },
  {
    src: "https://framerusercontent.com/images/mayiEAf4mBup41J0aYgossE.webp?width=2000",
    caption: "Calentamiento",
  },
  {
    src: "https://framerusercontent.com/images/xMPOHVtmOu8qyruZ32LX5oRhC4.webp?width=2000",
    caption: "Concentración",
  },
  {
    src: "https://framerusercontent.com/images/rtZ0SYbmp33hh3pshhUNAAr54g.webp?width=2000",
    caption: "Tribuna",
  },
  {
    src: "https://framerusercontent.com/images/Oeku98qY8S9GUAwcY5UTY3BSYjk.webp?width=2000",
    caption: "Formación inicial",
  },
  {
    src: "https://framerusercontent.com/images/CbQ7Y1NkmGKpxnnO0SnjUx51cec.webp?width=2000",
    caption: "Acción en el campo",
  },
];

// Trophy images (real, from original site)
export const TROPHIES = [
  {
    year: "2020/21",
    title: "Bombonera Campeón en Pandemia",
    cat: "Liga Local",
    img: "https://framerusercontent.com/images/8SjNIDhmbAEz2PefDQ4o1too.jpeg?width=1200",
  },
  {
    year: "2018/19",
    title: "C.D. La Bombonera Futbol7B",
    cat: "Categoría F7B",
    img: "https://framerusercontent.com/images/rpw1KnGnLrpZ8Ggk55YAnEzBC8.jpg?width=1200",
  },
  {
    year: "2017/18",
    title: "La Bombonera F7A — Campeón",
    cat: "Liga F7A",
    img: "https://framerusercontent.com/images/qLhiCTLYOyp81zvwiX94eOECDY.jpg?width=1200",
  },
  {
    year: "2017",
    title: "Copa Intercontinental BCN",
    cat: "Copa Internacional",
    img: "https://framerusercontent.com/images/7IX192OFCzKYFIVte4MulDTiU.jpg?width=1200",
  },
  {
    year: "2016",
    title: "Campeón de la Copa de Barcelona",
    cat: "Copa Regional",
    img: "https://framerusercontent.com/images/46Ka2OjWA8rDM8ShwXtINFVuiv0.jpeg?width=1200",
  },
];

// Real merch / kit imagery
export const MERCH = [
  "https://framerusercontent.com/images/e76uldAM2BNcat6kgsapxN28.jpg?width=1800",
  "https://framerusercontent.com/images/4SRThPiJyTUIebFCiH4upZAY.jpg?width=1800",
];

// Real partner logos
export const PARTNER_LOGOS = [
  "https://framerusercontent.com/images/8U80B30VL3BUlMNZ2gI6IMM3AOg.png?width=600",
  "https://framerusercontent.com/images/FuPYaycuz3xLPA5lgoxjShcbYQ.png?width=600",
  "https://framerusercontent.com/images/QxLNhqn71t0iqxbpFry7w8G00Y.png?width=600",
  "https://framerusercontent.com/images/GAdDpCbg4MB95RD2fVxsTL7ZQ.svg?width=600",
];
